import Enum from '@square/dashboard-utilities/utils/enum';

// GroupItemType allows differentiating between the regular group items (backed
// by a rolodex Group / Segment) and the hard-coded items (All)
export default new Enum(['ALL', 'GROUP', 'SEGMENT']);